import "./StartLearning.module.css";
import Header from "@/reusable_sections/Header";
import LetsCollaborate from "./sections/LetsCollaborate";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import CalendarBooking from "./sections/CalendarBooking";
import Footer from "@/reusable_sections/Footer";
export default function StartLearningPage() {
  return <div>
      <Header />
      <CalendarBooking />
      <LetsCollaborate />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}